export default "__VITE_ASSET__68fac72f__"